import React, { Component } from 'react'
import { Form, FormInstance, Radio, Select } from 'antd'
import { ShelterContextData } from 'context/ShelterContext'
import { DEFAULT_SELECT_FILTER_OPTION } from 'helpers/form-fields.helper'
import { ScopeMode } from '../types'
import { resolveScopeMode } from '../resolvers'

type ScopeFieldProps = {
  form: FormInstance
  shelterContext: ShelterContextData
}

type ScopeFieldState = {
  scopeMode: ScopeMode
}

/**
 * Global-vs-per-shelter scope picker. Owns its own `scopeMode` state (derived from
 * the form's `shelter_uuid`) so the host form doesn't need to track it. When the
 * user goes global the shelter is cleared, so an edited record is moved back to
 * global scope on save.
 */
export class ScopeField extends Component<ScopeFieldProps, ScopeFieldState> {
  state: ScopeFieldState = { scopeMode: resolveScopeMode(this.props.form) }

  componentDidMount() {
    // Initial values may settle after the Form mounts — re-resolve.
    const scopeMode = resolveScopeMode(this.props.form)
    if (scopeMode !== this.state.scopeMode) {
      this.setState({ scopeMode })
    }
  }

  handleChange = (scopeMode: ScopeMode) => {
    if (scopeMode === 'global') {
      this.props.form.setFieldsValue({ shelter_uuid: null })
    }
    this.setState({ scopeMode })
  }

  render() {
    const { shelterContext } = this.props
    const { scopeMode } = this.state
    const shelterOptions = shelterContext.shelters?.map(shelter => ({
      label: shelter.name,
      value: shelter.uuid,
    }))

    return (
      <>
        <Form.Item label="Apply to">
          <Radio.Group
            optionType="button"
            buttonStyle="solid"
            value={scopeMode}
            onChange={e => this.handleChange(e.target.value)}
          >
            <Radio.Button value="global">All shelters (global)</Radio.Button>
            <Radio.Button value="shelter">Specific shelter</Radio.Button>
          </Radio.Group>
        </Form.Item>

        <Form.Item
          label="Shelter"
          name="shelter_uuid"
          hidden={scopeMode !== 'shelter'}
          rules={scopeMode === 'shelter' ? [{ required: true, message: 'Missing a shelter' }] : []}
          help="Pick a shelter for a per-shelter override."
        >
          <Select
            showSearch
            filterOption={DEFAULT_SELECT_FILTER_OPTION}
            loading={shelterContext.fetching}
            placeholder="Select a shelter"
            options={shelterOptions}
          />
        </Form.Item>
      </>
    )
  }
}
